export enum DataSynchronisationStatus {
    SUCCESS = "success",
    ABORTED = "aborted",
    ERROR = "error",
    NONE = "none"
}

export interface DataSynchronizerStats {
    maxNbToSynchronize: number,
    currentNbSychronized: number,
    lastSynchroDuration: number | null,
    lastSynchroDate: number | null,
    lastSynchroStatus: DataSynchronisationStatus | null
}

export interface DataUpdateCacherStats {
    date: number,
    status: DataSynchronisationStatus
}